const UpgradeAcctIcon = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.3333 16.6273V25.6667H4.66666C4.66629 24.242 4.99206 22.8362 5.619 21.5569C6.24595 20.2777 7.15742 19.1589 8.28358 18.2864C9.40974 17.4138 10.7207 16.8106 12.116 16.5231C13.5113 16.2355 14.9539 16.2712 16.3333 16.6273ZM14 15.1667C10.1325 15.1667 6.99999 12.0342 6.99999 8.16666C6.99999 4.29916 10.1325 1.16666 14 1.16666C17.8675 1.16666 21 4.29916 21 8.16666C21 12.0342 17.8675 15.1667 14 15.1667ZM21.6837 19.8333L19.5498 17.7007L21.2007 16.0498L26.1497 21L21.2007 25.9502L19.5498 24.2993L21.6837 22.1667H17.5V19.8333H21.6837Z"
        fill="black"
      />
    </svg>
  );
};

export default UpgradeAcctIcon;
